import { Routes, RouterModule } from '@angular/router';
import { StateMachinesComponent } from './statemachines.component';

const routes: Routes = [
    {
        path: '',
        component: StateMachinesComponent
    },
];

export const StateMachinesRoutes = RouterModule.forChild(routes);
